/**
 * 平台禁用的多媒体键列表
 *
 * 对应 C++ 项目 KeyBoardDataHandler.h 中的 win_disable / linux_disable / mac_disable。
 * 当前平台列表中包含的 keywords 应在改键面板中隐藏。
 */

import { isMacOS, isWindows } from './ua'

const winDisable: string[] = []
const linuxDisable: string[] = []
const macDisable: string[] = [
  'Music',
  '📱',
  '✉',
  'PC',
  '🏠',
  'Browser_Back',
  'Browser_Forward',
  'Browser_Refresh',
  'Browser_Stop',
  'Browser_Search',
  'Browser_Favorites',
]

const disableList = isMacOS ? macDisable : isWindows ? winDisable : linuxDisable

/** 当前平台禁用的 keywords 集合 */
export const DISABLED_KEYWORDS = new Set(disableList)
